import dataloader from './dataloader'
import Bus from 'src/helpers/bus'
import { post } from 'src/axios/post'
import { ungrant } from 'src/notifications/push'
import { store } from 'src/store'

// URL and endpoint constants
const LOGIN_URL = '/v1/user/signIn'
const CLIENT_CONNECT_LOGIN_URL = 'v1/clientConnect/signIn'
const CLIENT_CONNECT_SIGNUP_URL = '/v1/clientConnect/register'
const BUSINESS_SIGNUP_URL = '/v1/register/business'
const LOGOUT_URL = '/v1/user/logout'
const PASSWORD_FORGOT_URL = '/v1/user/password/forgot'
const PASSWORD_RESET_URL = '/v1/user/password/reset'

export default {
  async login (type, send, onSuccess, onError) {
    let url = LOGIN_URL
    switch (type) {
      case 'client-connect-login': url = CLIENT_CONNECT_LOGIN_URL; break
      case 'client-connect-signup': url = CLIENT_CONNECT_SIGNUP_URL; break
      case 'business-login': url = LOGIN_URL; break
      case 'business-signup': url = BUSINESS_SIGNUP_URL; break
    }

    const { status, payload, errors, message } = await post(url, send)
    if (status === 'success') {
      store.dispatch('login', {
        access_token: payload.token,
        portal: payload.portal
      }).then(async () => {
        await onSuccess(payload.token)
      })
    }
    else {
      onError((errors || {}), message)
    }
  },

  async forgotPassword (context, creds, onSuccess, onError) {
    const { status, errors } = await post(PASSWORD_FORGOT_URL, creds)
    if (status === 'success') {
      onSuccess()
    }
    else {
      onError((errors || {}))
    }
  },

  async resetPassword (context, creds, onSuccess, onError) {
    const { status, errors, message } = await post(PASSWORD_RESET_URL, creds)
    if (status === 'success') {
      onSuccess()
    }
    else {
      onError((errors || {}), message)
    }
  },

  async logout (doneFunc) {
    ungrant()
    dataloader.setDone(false)
    Bus.emit('Logout')

    const { status } = await post(LOGOUT_URL, {
      guid: store.getters.getGuid
    })
    if (status === 'success') {
      store.dispatch('logout')
        .then(doneFunc)
    }
  }
}
